import CrmCommandHandler from 'crm-command-handler/CrmCommandHandler';
import { getI18nProvider } from 'quartz-core/framework/i18n';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CommandHandler() {
  return /*#__PURE__*/_jsx(CrmCommandHandler, {
    i18nLoader: getI18nProvider(),
    floatingAlertStoreInstance: FloatingAlertStore
  });
}